var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"UnnamedAptListModal",attrs:{"size":"xl fluid","title":"รายการนัดหมายคนไข้ใหม่ไม่มีประวัติ","hide-footer":"","no-close-on-backdrop":""}},[_c('AppointmentHistoryTable',{attrs:{"patient":_vm.patient,"mode":_vm.mode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }